import type { Feature } from '@luna/gatekeeper';

export const creditCardReissueExternal: Feature = {
    enabled: true,
    _description: 'Enables external card reissue section under services',
};
